// CU Boulder's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026-2027 University Catalog (catalog.colorado.edu), whose
// Colleges, Schools & Programs menu lists every program under the college or
// school that offers it: every bachelor's line kept, with the catalog's own
// degree abbreviations (BA, BS, BSBA, BEV, BMus, ...); minors, certificates
// and graduate programs left out. Left out as well: "Applied Computer
// Science - Post-Baccalaureate Bachelor of Science (BSACS)", which the
// catalog labels post-baccalaureate. Exploratory Studies,
// Academic Enrichment Programs and Cross-College Programs list no bachelor's
// majors. Group names are the catalog's own. The Music flag quotes the
// first-year Apply for Admission page (the college file's `apply` source).
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-colorado-boulder",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in CU Boulder's 2026-2027 University Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Arts & Sciences",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Arts & Sciences",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/arts-sciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art Practices",
                    "degree": "BA"
                },
                {
                    "name": "Art Practices",
                    "degree": "BFA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysical and Planetary Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysical and Planetary Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric and Oceanic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Cinema Studies & Moving Image Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Cinema Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Physiology",
                    "degree": "BS"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Molecular, Cellular and Developmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Women and Gender Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Business",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Business",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/business/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "BSBA"
                },
                {
                    "name": "Integrated Business and Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Communication, Media, Design & Information",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Communication, Media, Design & Information",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/communication-media-design-information/"
            },
            "majors": [
                {
                    "name": "Strategic Communication",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Media Production",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BEV"
                },
                {
                    "name": "Environmental Products of Design",
                    "degree": "BEV"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BEV"
                },
                {
                    "name": "Sustainable Planning and Urban Design",
                    "degree": "BEV"
                },
                {
                    "name": "Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Education",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Education",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/education/"
            },
            "majors": [
                {
                    "name": "Education Studies",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "Leadership and Community Engagement",
                    "degree": "BA"
                },
                {
                    "name": "Middle and High School Teaching",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Engineering & Applied Science",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Engineering & Applied Science",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/engineering-applied-science/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering Sciences",
                    "degree": "BSAE"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BSAM"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBM"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BSARE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCV"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEV"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS"
                },
                {
                    "name": "Creative Technology and Design",
                    "degree": "BSCTD"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BSEC"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BSEP"
                },
                {
                    "name": "Integrated Design Engineering",
                    "degree": "BSIDE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Music",
            "source": {
                "label": "CU Boulder 2026-2027 University Catalog, Music",
                "url": "https://catalog.colorado.edu/undergraduate/colleges-schools/music/"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "BAMus",
                    "flag": "Needs a separate College of Music application and an audition.",
                    "flagSource": "apply"
                },
                {
                    "name": "Music",
                    "degree": "BMus",
                    "flag": "Needs a separate College of Music application and an audition.",
                    "flagSource": "apply"
                },
                {
                    "name": "Music Education",
                    "degree": "BMUE",
                    "flag": "Needs a separate College of Music application and an audition.",
                    "flagSource": "apply"
                }
            ]
        }
    ]
};

export default majors;
